import { render, staticRenderFns } from "./order_confirm.vue?vue&type=template&id=4b27d971&scoped=true&"
import script from "./order_confirm.vue?vue&type=script&lang=js&"
export * from "./order_confirm.vue?vue&type=script&lang=js&"
import style0 from "./order_confirm.vue?vue&type=style&index=0&id=4b27d971&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b27d971",
  null
  
)

export default component.exports